import { Component, OnInit, OnDestroy } from '@angular/core';
import { setTheme } from 'ngx-bootstrap/utils';
import { RouterModule } from '@angular/router';
import { NgSelectConfig } from '@ng-select/ng-select';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ErrorService } from './core/services/error.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'The Landlord Portal';
  private errorSubscription?: Subscription;

  constructor(
    private ngSelectConfig: NgSelectConfig,
    private errorService: ErrorService,
    private toastr: ToastrService
  ) {
    // set up ng-select global config
    this.ngSelectConfig.notFoundText = 'Not found';
    this.ngSelectConfig.appendTo = 'body';

    // npx theme
    setTheme('bs5');
  }

  ngOnInit(): void {
    // Subscribe to error service to show toast notifications application-wide
    this.errorSubscription = this.errorService.apiError$.subscribe(error => {
      if (error) {
        const title = error.statusCode !== 200 ? `Error ${error.statusCode}` : 'Error';
        const message = error.message || 'An unexpected error occurred';
        
        this.toastr.error(message, title, {
          timeOut: 5000,
          closeButton: true,
          progressBar: true
        });
        
        // Clear the error after showing the toast
        this.errorService.setApiError(null);
      }
    });
  }

  ngOnDestroy(): void {
    // Clean up subscription to prevent memory leaks
    if (this.errorSubscription) {
      this.errorSubscription.unsubscribe();
    }
  }
}
